import { useCallback } from 'react';
import { Lead, LeadAvailablePipelineAction } from 'models/Leads';
import { openInboxForLead } from 'utils/inbox/inboxUtils';
import useOpenAirbnbAlterationRequestModal from 'components/domain/airbnbAlterationRequest/useOpenAirbnbAlterationRequestModal';

const useLeadPipelineActionCustomHandler = () => {
  const { updateAirbnbAlterationRequestModal } =
    useOpenAirbnbAlterationRequestModal();

  return useCallback(
    ({ action, lead }: { action: LeadAvailablePipelineAction; lead: Lead }) => {
      if (action === LeadAvailablePipelineAction.OPEN_INBOX) {
        const { uid: leadUid } = lead;

        openInboxForLead(leadUid);

        return;
      }

      if (action === LeadAvailablePipelineAction.AIRBNB_REVIEW_ALTERATION) {
        updateAirbnbAlterationRequestModal(lead);

        return;
      }

      throw new Error(`Not implemented lead action: ${action}`);
    },
    [],
  );
};

export default useLeadPipelineActionCustomHandler;
